export default "__VITE_ASSET__KmMMj94Q__"